// src/ArticleForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function ArticleForm() {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!title || !description) {
            setError('Le titre et la description sont requis');
            return;
        }

        try {
            await axios.post(`https://bd.delightsrecipes.com/api/articles`, {
                title,
                description
            });
            navigate('/articles');
        } catch (err) {
            setError('Erreur lors de la création de l\'article');
        }
    };

    return (
        <div>
            <h2>Créer un nouvel article</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Titre:</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div>
                    <label>Description:</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <button type="submit">Créer l'article</button>
            </form>
        </div>
    );
}

export default ArticleForm;
